var render = function render(){var _vm=this,_c=_vm._self._c;return _c('l-map',{staticStyle:{"height":"100vh","width":"100%"},attrs:{"zoom":_vm.zoom,"center":_vm.center},on:{"click":_vm.emitClick}},[_c('l-tile-layer',{attrs:{"url":"https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"}}),(_vm.geoData)?_c('l-geo-json',{attrs:{"geojson":_vm.geoData,"options":_vm.geoJsonOptions}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }